import { Divider } from 'antd';

function FisheryProfileSectionLayout({
  title,
  extra = undefined,
  justifyTitleDiv = 'flex-start',
  centreTitle = false,
  children,
  level = 2,
  noDivider = false,
  ...otherProps
}) {
  return (
    <div className={'fishery_profile__section'} {...otherProps}>
      <div
        className={'fishery_profile__section__title '}
        style={{ justifyContent: justifyTitleDiv }}
      >
        {level === 2 && (
          <h2
            className={
              'gSemiBold ' + (centreTitle ? ' w-full txt-center ' : '')
            }
          >
            {title}
          </h2>
        )}
        {level === 3 && (
          <h3
            className={
              'gSemiBold ' + (centreTitle ? ' w-full txt-center ' : '')
            }
          >
            {title}
          </h3>
        )}
        {extra || ''}
      </div>
      {children}
      {!noDivider && <Divider />}
    </div>
  );
}
export const FisheryProfileSection = (props) => (
  <FisheryProfileSectionLayout level={2} {...props} />
);
export const FisheryProfileSubSection = (props) => (
  <FisheryProfileSectionLayout
    level={3}
    noDivider
    justifyTitleDiv={'space-between'}
    {...props}
  />
);
